<template>
  <button type="button" class="client-skin-entry" :class="{'icon-only':iconOnly}" aria-label="皮肤" title="皮肤" @click="openPicker">
    <svg-icon v-if="iconOnly" icon="client-skin" /><span v-else>皮肤</span>
  </button>
  <a-modal v-model:visible="visible" title="选择皮肤" :footer="null" :width="480">
    <div class="client-skin-options">
      <button v-for="skin in skins" :key="skin.id" type="button" :aria-pressed="selected===skin.id" @click="choose(skin.id)">
        <span class="swatch" :style="{background:skin.color}" aria-hidden="true"></span>
        <span>{{skin.name}}</span><span v-if="selected===skin.id" aria-hidden="true">✓</span>
      </button>
    </div>
    <a-button class="restore-shop-skin" @click="choose(null)">恢复店铺默认</a-button>
  </a-modal>
</template>
<script setup lang="ts">
import {ref,watch,onBeforeUnmount} from 'vue'
import {message} from 'ant-design-vue'
import store from '@/store'
import {miniappSkins} from '@/config/miniappSkins'
import {usePersonalAdminSkin,selectPersonalAdminSkin,currentAdminSkin} from '@/utils/adminSkin'
const iconOnly=true,visible=ref(false),selected=ref('classic')
const skins=miniappSkins.map(s=>({id:s.value,name:s.label,color:s.colors[0]}))
watch(()=>JSON.stringify([store.getters.userInfo?.orgId,store.getters.userInfo?.id]),()=>{visible.value=false;usePersonalAdminSkin(Number(store.getters.userInfo?.orgId),Number(store.getters.userInfo?.id))},{immediate:true})
const openPicker=()=>{selected.value=currentAdminSkin();visible.value=true}
const choose=(id:string|null)=>{if(!selectPersonalAdminSkin(Number(store.getters.userInfo?.orgId),Number(store.getters.userInfo?.id),id)){message.warning('暂时无法保存皮肤选择，请稍后重试。');return}selected.value=currentAdminSkin()}
onBeforeUnmount(()=>usePersonalAdminSkin(0,0))
</script>
<style scoped>
.client-skin-entry.icon-only{display:inline-flex;align-items:center;justify-content:center;width:35px;height:35px;padding:0;border:0;background:transparent;color:inherit;cursor:pointer;flex-shrink:0}
.client-skin-entry.icon-only :deep(svg){width:30px;height:30px;font-size:30px}
.client-skin-entry:focus-visible{outline:2px solid var(--activeColor);outline-offset:2px}
.client-skin-options{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}
.client-skin-options button{display:flex;align-items:center;justify-content:center;gap:6px;padding:12px 5px;border:1px solid #ddd;border-radius:7px;background:transparent;color:inherit;cursor:pointer}
.client-skin-options button[aria-pressed="true"]{border-color:var(--activeColor);box-shadow:0 0 0 1px var(--activeColor)}
.swatch{width:16px;height:16px;border-radius:50%;flex-shrink:0}.restore-shop-skin{margin-top:18px}
</style>
